import * as cartService from '/source/js/services/cartService';
import { loadSpinner, stopSpinner } from '/source/_patterns/01-components/spinner/spinner';
import { announceAddedToCart } from '/source/js/utils/announceUtil';

const tabSelector = '.featured-product-navigation__tab';
const tabContentSelector = '.featured-product-navigation__tab-content';
const promoBannerSelector = '.featured-promo-banner__wrapper';
const sliderSelector = '.featured-product-navigation__list';
const qtyIncreaseSelector = '.increase-items';
const qtyDecreaseSelector = '.decrease-items';
const addToCartSelector = '.addFeaturedProductToCard';
let resizeTimeout;
let ShouldSlick = true;
let noOfSlidesToShow = 1;
let SLICK_CONFIG = {};
let IdsList = [];

const breakpoints = {
    large: 1160,
    medium: 992,
    small: 768
};

$('#btn-dont-ask-again').on('click', saveShopLaterPreference);

function updateSlickConfig() {
    const updatedConfig = {
        dots: true,
        infinite: false,
        speed: 300,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev custom-prev-arrow" aria-label="Previous"><i class="fas fa-circle-arrow-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next custom-next-arrow" aria-label="Next"><i class="fas fa-circle-arrow-right"></i></button>',
        slidesToShow: noOfSlidesToShow,
        slidesToScroll: noOfSlidesToShow
    };

    SLICK_CONFIG = updatedConfig;
}

function handleTabClick(e) {
    hideCartOverlay();
    const $tab = $(e.currentTarget);
    const tabId = $tab.data('tab');
    $(tabSelector)
        .removeClass('active')
        .attr('aria-selected', 'false');
    $tab.addClass('active').attr('aria-selected', 'true');

    $(tabContentSelector)
        .removeClass('active');
    $(`#${tabId}`).addClass('active');

    $(promoBannerSelector).fadeOut(400);
    initializeSlider();
}

function initializeSlider() {
    const $activeSlider = $(`${tabContentSelector}.active ${sliderSelector}`);
    const $allSliders = $(`.featured-product-navigation__tab-menu-container ${sliderSelector}`);
    $allSliders.each(function () {
        if($(this).hasClass('slick-initialized')) {
            $(this).slick('unslick');
        }
    });

    if($activeSlider.length > 0) {
        if($activeSlider.hasClass('slick-initialized')) {
            $activeSlider.slick('unslick');
        }

        updateSlidesToShowCount($activeSlider);
        if(ShouldSlick) {
            updateSlickConfig();
            $activeSlider.slick(SLICK_CONFIG);
        }
        ShouldSlick = true;
        noOfSlidesToShow = 1;
    }

    fixImageContainersHeight($activeSlider, '.featured-product-navigation__product-image-container');
    fixImageContainersHeight($activeSlider, '.featured-product-navigation__product-title');
    fixImageContainersHeight($activeSlider, '.featured-product-navigation__product-cta');
}

function fixImageContainersHeight(activeTab, containerSelector) {
    const $containers = $(activeTab).find(`${containerSelector}`);
    let maxHeight = 0;
    let reduceHeight = false;
    $containers.each(function () {
        $(this).height('auto');
    });
    $containers.each(function () {
        const height = $(this).outerHeight();
        if(height > maxHeight) {
            maxHeight = height;
        }
        if($(this).hasClass('is-cs') && !reduceHeight) {
            reduceHeight = true;
        }
    });
    if(reduceHeight && !maxHeight) {
        maxHeight = maxHeight - 16;
    }
    $containers.each(function () {
        $(this).height(maxHeight);
    });
}

function resetSlickCarousel() {
    const $allSliders = $(`.featured-product-navigation__tab-menu-container ${sliderSelector}`);
    $allSliders.each(function () {
        if($(this).hasClass('slick-initialized')) {
            $(this).slick('unslick');
        }
    });
}

function updateSlidesToShowCount($activeSlider) {
    const count = $($activeSlider).find('.featured-product-navigation__list-item').length;
    if(window.matchMedia(`(max-width: ${(breakpoints.small - 1)}px)`).matches) {
        noOfSlidesToShow = 1;
        if(count <= 1) ShouldSlick = false;
    } else if(window.matchMedia(`(max-width: ${(breakpoints.medium - 1)}px)`).matches) {
        noOfSlidesToShow = 2;
        if(count <= 2) ShouldSlick = false;
    } else if(window.matchMedia(`(max-width: ${(breakpoints.large - 1)}px)`).matches) {
        noOfSlidesToShow = 3;
        if(count <= 3) ShouldSlick = false;
    } else if(window.matchMedia(`(min-width: ${(breakpoints.large)}px)`).matches) {
        noOfSlidesToShow = 4;
        if(count <= 4) ShouldSlick = false;
    }
}

const updateQuantity = (direction, $btn) => {
    const $input = $btn.siblings('.quantity-input');
    const value = parseInt($input.val() || 0);
    const min = parseInt($input.attr('min'));
    const max = parseInt($input.attr('max'));
    const newValue = direction === 'increase'
        ? Math.min(value + 1, max)
        : Math.max(value - 1, min);

    $input.val(newValue);
    if($btn.hasClass('increase-items')) {
        $btn.prop('disabled', newValue === max);
        $btn.siblings(qtyDecreaseSelector).prop('disabled', false);
    }

    if($btn.hasClass('decrease-items')) {
        $btn.prop('disabled', newValue === min);
        $btn.siblings(qtyIncreaseSelector).prop('disabled', false);
    }
};

const addToCart = async (e) => {
    const $btn = $(e.currentTarget);
    const $parent = $btn.closest('.featured-product-navigation__list-item');
    const quantity = $parent.find('.price__quantity-sign--amount').val();
    loadSpinner();
    try {
        let request = {
            FamilyId: $btn.data('familyid'),
            ProductId: `Isagenix_Master|${$btn.data('id')}|`,
            Quantity: quantity,
            ProductPageRelativeUrl: $btn.data('url'),
            PriceType: $btn.data('pricetype'),
            TryOnce: false,
            IsQuickAdd: true
        };
        let result;
        const isKit = $btn.data('iskit');
        if(isKit !== undefined && isKit === true) {
            request.BundleConfigurationId = undefined;
            request.Sku = $btn.data('sku');
            result = await cartService.addKitToCart(request);
        } else {
            request.FamilyName = $btn.data('familyname');
            result = await cartService.addToCart(request);
        }

        if(result.IsSuccessful) {
            cartService.updateQSForMergeCart();
            const selectedCardElement = $parent.find('.card-selected');
            $(selectedCardElement).removeClass('d-none');
            $(selectedCardElement).removeClass('card-unselected');
            const cardId = $(selectedCardElement).attr('id');
            if(!IdsList.includes(cardId)) {
                IdsList.push(cardId);
            }
            const timeoutId = setTimeout(() => {
                hideCartOverlay();
                clearTimeout(timeoutId);
                $($btn).blur();
            }, 4000);
            $('.header__cart-items').text(result.QuantityTotal).removeClass('d-none');
            announceAddedToCart(result.Name || result.ProductName || '', result.QuantityTotal);
            $btn.closest('.featured-product-navigation__tab-menu-container').find('a.cart-button').removeClass('promo-button-primary--disabled button-primary--disabled');
        }
    } catch (error) {
        console.error(error);
    }
    stopSpinner();
};

function hideCartOverlay() {
    const items = IdsList.filter((item, index) => IdsList.indexOf(item) === index);
    IdsList.forEach(function (element) {
        const idSelector = '#' + element;
        if(!$(idSelector).hasClass('d-none')) {
            $(idSelector).addClass('d-none');
        }
        if(!$(idSelector).hasClass('card-unselected')) {
            $(idSelector).addClass('card-unselected');
        }
        items.pop(element);
    });
    IdsList = items;
}

const handleTrendingLinkClick = (e) => {
    e.preventDefault();
    const $link = $(e.currentTarget);
    const $parent = $($link).closest('.featured-product-navigation__tab-menu-container');
    $parent.find('.featured-product-navigation__tab-content, .featured-product-navigation__tab').each(function () {
        if($(this).data('id') === 'trending') {
            $(this).addClass('active')
                .attr('aria-selected', 'true');
        } else {
            $(this).removeClass('active')
                .attr('aria-selected', 'false');
        }
    });
    $(promoBannerSelector).fadeOut(400);
    initializeSlider();
};

function startCountdown($timerElement) {
    const showsHours = $timerElement.data('shows-hours') === true || $timerElement.data('shows-hours') === 'True';
    const large = parseInt($timerElement.data('large')) || 0;
    const medium = parseInt($timerElement.data('medium')) || 0;
    const small = parseInt($timerElement.data('small')) || 0;

    let totalSeconds = 0;
    const timerId = $($timerElement).attr('id');
    const cielElement = $($timerElement).closest('.featured_promo-timer').find(`#a${timerId}`);
    let initialCielValue = -1;
    if(showsHours) {
        totalSeconds = large * 3600 + medium * 60 + small - 1;
    } else {
        totalSeconds = large * 86400 + medium * 3600 + small * 60 - 60;
    }
    const interval = setInterval(() => {
        if(totalSeconds < 0) {
            clearInterval(interval);
            return;
        }
        let display = '';
        if(showsHours) {
            const h = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
            const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
            const s = String(totalSeconds % 60).padStart(2, '0');
            display = `${h}H : ${m}M : ${s}S`;
            totalSeconds--;
            const intH = parseInt(h);
            const intM = parseInt(m);
            const intS = parseInt(s);
            if(initialCielValue === -1) {
                initialCielValue = intH;
            } else if(intH === 0 && intM === 0 && intS === 0) {
                clearInterval(interval);
            }

            if(initialCielValue !== intH || (intH === 0) || (intM === 0 && intS === 0)) {
                let cielVal = intH === 0 ? 0 : intM === 0 && intS === 0 ? intH : intH + 1;
                $(cielElement).text((cielVal));
                initialCielValue = intH;
            }
        } else {
            const d = String(Math.floor(totalSeconds / 86400)).padStart(2, '0');
            const h = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(2, '0');
            const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
            display = `${d}D : ${h}H : ${m}M`;
            totalSeconds = totalSeconds - 60;
            const intH = parseInt(h);
            const intM = parseInt(m);
            const intD = parseInt(d);
            if(initialCielValue === -1) {
                initialCielValue = intD;
            } else if(intH === 0 && intM === 0 && intD === 0) {
                clearInterval(interval);
            }

            if((initialCielValue !== intD) || (intD === 0) || (intM === 0 && intH === 0)) {
                let cielVal = intD === 0 ? 0 : ((intM === 0 && intH === 0) ? intD : intD + 1);
                $(cielElement).text((cielVal));
                initialCielValue = intD;
            }
        }

        $timerElement.text(display);
    }, showsHours ? 1000 : 60 * 1000);
}

const initEventHandlers = () => {
    if($('.featured-product-navigation').length) {
        $(tabSelector).on('click', handleTabClick);
        $(`.featured-product-navigation ${qtyIncreaseSelector}`).on('click', (e) => updateQuantity('increase', $(e.currentTarget)));
        $(`.featured-product-navigation ${qtyDecreaseSelector}`).on('click', (e) => updateQuantity('decrease', $(e.currentTarget)));
        $(`.featured-product-navigation ${addToCartSelector}`).on('click', addToCart);
        $('.featured-product-navigation__trending-link').on('click', handleTrendingLinkClick);
    }
};

$(function () {
    initEventHandlers();
    $('.featured_promo-timer').each(function () {
        startCountdown($(this).find('.right-label'));
    });

    $('.price__quantity-sign--amount').on('blur', function() {
        const $input = $(this);
        let val = parseFloat($input.val());
        const max = parseFloat($input.attr('max'));
        const $inc = $input.siblings(qtyIncreaseSelector);
        const $dec = $input.siblings(qtyDecreaseSelector);
        if(isNaN(val)) {
            val = 1;
        }
        if(val >= max) {
            $input.val(max);
            $inc.prop('disabled', true);
            $dec.prop('disabled', false);
        } else if(val <= 1) {
            $input.val(1);
            $dec.prop('disabled', true);
            $inc.prop('disabled', false);
        } else {
            $inc.prop('disabled', false);
            $dec.prop('disabled', false);
        }
    });

    if($('.featured-product-navigation__tab-container').length) {
        $('.featured-product-navigation__tab-container').on('touchstart', function () {
            $(this).addClass('hover-mobile');
        });
        $('.featured-product-navigation__tab-container').on('touchend touchcancel', function () {
            $(this).removeClass('hover-mobile');
        });
    }
});

$(window).on('resize', debounce(() => {
    resetSlickCarousel();
    initializeSlider();
}, 100));

function debounce(func, wait) {
    return function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(func, wait);
    };
}

function saveShopLaterPreference() {
    var data = {
        memberId: $('#hdn-memberid').val()
    };

    cartService.saveShopLaterPreference(data).then(result => {
        window.location.href = $('#hdn-dashboard-cta-url').val();
    });
}
